module.exports = __webpack_public_path__ + "static/media/fremod002.9b30c945.png";